<highcharts-chart
  *ngIf="this.data?.myBrand?.length"
  id="container"
  [Highcharts]="Highcharts"
  [constructorType]="'mapChart'"
  [options]="chartOptions">
</highcharts-chart>
<app-loader *ngIf="loading"></app-loader>

<app-no-widget-data *ngIf="!this.data?.myBrand?.length && !loading"></app-no-widget-data>

